import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

export interface PaginatedResponse<T> {
    count: number;
    total_pages: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

export const fetchSupplierStockOverview = createAsyncThunk(
    "inventory/fetchSupplierStockOverview",
    async ({
        page,
        pageSize,
        sort,
        order,
        search,
        filters,
        warehouseId,
    }: {
        page: number;
        pageSize: number;
        search?: string;
        sort?: string;
        order?: "asc" | "desc" | "";
        filters?: any;
        warehouseId?: string;
    }) => {
        try {
            const params = new URLSearchParams();
            params.append("page", page.toString());
            params.append("page_size", pageSize.toString());
            params.append("warehouse_id", warehouseId?.toString() || "");

            if (search) params.append("search", search);
            if (sort) {
                const orderingValue = order === "desc" ? `-${sort}` : sort;
                params.append("ordering", orderingValue);
            }

            const filterPayload = FilterBuilder(filters ?? []);


            const body = {
                filters: filterPayload,
            };

            const response: any = await InventoryAxios.post(
                `${API_ENDPOINT.INVENTORY.IN_STOCK.SupplierStock.LIST}?${params.toString()}`,
                body
            );
            return {
                data: response.data.data || [],
                rowCount: response.data.totalRecords || 0,
            };
        } catch (error: any) {
            console.error(
                "fetch Inventory List error:",
                error.response?.data || error.message
            );
            throw new Error("Network Error");
        }
    }
);

export const exportSupplierStockCSV = async ({
    warehouse_id,
    search,
    filters,
}: {
    warehouse_id: string;
    search?: string;
    filters?: any[];
}) => {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    params.append("warehouse_id", warehouse_id);

    const filterPayload = FilterBuilder(filters ?? []);
    const body = {
        filters: filterPayload,
    };

    const response = await InventoryAxios.post(
        `${API_ENDPOINT.INVENTORY.IN_STOCK.SupplierStock.EXPORT}?${params.toString()}`,
        body,
        {
            responseType: "blob",
        }
    );

    return {
        blob: response.data,
        filename:
            response.headers["content-disposition"]
                ?.split("filename=")[1]
                ?.replace(/"/g, "") ||
            `SupplierStock${new Date().toISOString().split("T")[0]}.csv`,
    };
};

